import { gameRoutes, type GameMeta, type SimpleDate } from '@puzzlio/core';
import type { HighlightConfig } from '@puzzlio/core';
import { colors } from '@puzzlio/tokens';

export const highlightConfigs: Record<string, HighlightConfig> = {
  // The purple is off-palette, and erase is a true white rather than the palette's slightly warm one.
  '1': { color: '#8575FC', label: 'Purple' },
  '2': { color: colors['gray-500'], label: 'Black' },
  erase: { color: '#FFFFFF', label: 'Erase' },
};

export const meta: GameMeta = {
  type: 'stars',
  gameId: 2,
  label: 'Stars',
  description: 'Place stars in a grid and don\'t let them touch',
  emoji: '⭐',
  buttonColor: 'yellow',
  // Neither of these is a palette entry; the page's yellow sits between yellow-200 and yellow-300.
  background: { fill: '#FEEA76', dot: '#FEE27C' },
  burst: { inner: colors['yellow-300'], outer: colors['yellow-default'] },
  separator: colors['yellow-600'],
  earliestDate: '2025-11-01' as SimpleDate,
  tutorialSlug: 'tutorial-1',
  practiceCollections: [
    { level: 1, puzzles: ['easy-1', 'easy-2', 'easy-3'] },
    { level: 2, puzzles: ['medium-1', 'medium-2', 'medium-3'] },
    { level: 3, puzzles: ['hard-1', 'hard-2', 'hard-3'] },
  ],
  enableHints: true,
  availability: 'available',
  highlightConfigs: highlightConfigs,
  ...gameRoutes('/games/stars'),
};
